<template>
    <v-dialog v-model="showDialog" max-width="500" content-class="delete-dialog" persistent>
        <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-text>{{ message }}</v-card-text>
            <v-card-actions>
                <v-btn
                    outline
                    color="info"
                    @click="onCancel()"
                >取消</v-btn>

                <v-btn
                    color="info"
                    @click="onConfirm()"
                >是的</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ConfirmDialog',

    props: {
        showDialog: {
            required: true,
            type: Boolean,
            default: false
        },
        title: {
            required: true,
            type: String,
        },
        message: {
            required: true,
            type: String,
        },
        onConfirm: {
            required: true,
            type: Function
        },
        onCancel: {
            required: true,
            type: Function
        }
    }
}
</script>